var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-link text-base font-normal normal-case underline hover:no-underline",attrs:{"type":"button"},on:{"click":_vm.uncheckAll}},[_vm._v("\n  Unsubscribe from all\n")])}
var staticRenderFns = []

export { render, staticRenderFns }